import { Button } from '@medly-components/core';
import { KeyboardArrowDownIcon } from '@medly-components/icons';
import styled from 'styled-components';

export const StyledButton = styled(Button).attrs({ hideUnderline: true, variant: 'flat' })`
    align-self: flex-start;
    padding: 1.8rem 0 0;
`;

export const ChevronIcon = styled(KeyboardArrowDownIcon)<{ showAll: boolean }>`
    &&& {
        position: relative;
        top: 0;
        right: 0;
        transform: ${({ showAll }) => (showAll ? 'rotate(180deg)' : 'rotate(0deg)')};
        transition: transform 100ms ease-in-out;
    }
`;
